import logo from './logo.svg';
import React, { useRef } from 'react';
import './App.css';
import Welcome from './components/Welcome';
import ResponsiveMenu from './components/ResponsiveMenu';
import OurStory from './components/OurStory';
import Program from './components/Program';
import Venue from './components/Venue';
import GuestBook from './components/Guestbook';

function App() {
  // Create refs for each section component
  const welcomeRef = useRef(null);
  const ourStoryRef = useRef(null);
  const programRef = useRef(null);
  const venueRef = useRef(null);
  const guestBookRef = useRef(null);

  // Function to scroll to a specific section
  const scrollToSection = (sectionRef) => {
    sectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <ResponsiveMenu scrollToSection={scrollToSection} sectionRefs={{ welcomeRef, ourStoryRef, programRef, venueRef, guestBookRef }} />
      
      {/* Section 1: Welcome */}
      <div ref={welcomeRef}>
        <Welcome />
      </div>

      {/* Section 2: Our Story */}
      <div ref={ourStoryRef}>
        <OurStory />
      </div>

      {/* Section 3: Program */}
      <div ref={programRef}>
        <Program />
      </div>

      {/* Section 4: Venue */}
      <div ref={venueRef}>
        <Venue />
      </div>

      {/* Section 4: Venue */}
      <div ref={guestBookRef}>
        <GuestBook />
      </div>
    </div>
  );
}

export default App;
